<template >
    <div class="page-header align-items-start min-vh-100 position-relative login-background">
        <span class="mask bg-gradient-light opacity-7"></span>
        <div class="container my-auto">
            <div class="row">
                <div class="col-lg-4 col-md-8 col-12 mx-auto">
                    <div class="card z-index-0 fadeIn3 fadeInBottom">                        
                        <div class="card-body">
                            <div class="text-center">
                                <img src="../../assets/img/Veeboek-logo.png" class="logo mb-2" alt="Vee Boek">
                            </div>
                            <div class="text-start mt-3">
                                <form @submit.prevent="logIn" id="loginForm">
                                    <div class="mb-3">
                                        <label class="form-label">{{ $t('login.User_name') }} *</label>
                                        <input type="text" class="input" v-model.trim="userName">
                                        <span class="error-message text-danger" v-if="!userName && attemptedLogin">{{ $t('login.Username_is_required') }}</span>
                                    </div>

                                    <div class="mb-3 position-relative">
                                        <label class="form-label">{{ $t('login.Password') }} *</label>
                                        <input :type="showPassword ? 'text' : 'password'" class="input" v-model.trim="password" id="password">

                                        <span class="material-symbols-outlined" @click="togglePassword" style="position:absolute; top:40px; right:10px; cursor:pointer;">
                                            {{ showPassword ? 'visibility' : 'visibility_off' }}
                                        </span>
                                        <span class="error-message text-danger" v-if="!password && attemptedLogin">{{ $t('login.Password_is_required') }}</span>
                                    </div>

                                    <div class="text-center"> 
                                        <button type="submit" class="btn bg-gradient-success btn-md w-100 my-3" :disabled="$store.state.showLoading">
                                            {{ $t('login.Log_in') }}
                                        </button>
                                    </div>                                    
                                    <div class="text-center">
                                        <router-link to="/forgot-password" class="text-sm text-green">{{ $t('login.Forgot_password') }}?</router-link>
                                        <!--
                                        <hr>
                                        <span class="text-sm text-muted">{{ $t('login.Not_registered') }}?</span>
                                        <router-link to="/signup" class="btn bg-gradient-light btn-md">{{ $t('login.Register_as_a_user') }}?</router-link>                                        
                                        -->
                                    </div>                                    
                                </form>                                                       
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <auth-footer />
    </div>
</template>
  
<script>
import axios from 'axios'
import AuthFooter from './Footer.vue';
import { mapMutations } from "vuex";

export default {
    name: "Log_In",
    components: {
        AuthFooter
    },
    data()
        {
            return {
                userName:'',
                password:'',
                showPassword: false,
                attemptedLogin: false,
                posts: []
            }
        },    
    mounted() {
    },
    computed: {        
    },   
    methods: {
        ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
        async logIn() {    
            try {
                this.attemptedLogin = true;

                if (!this.userName || !this.password) {
                    return;
                }

                this.$store.commit('setShowLoading', true);

                const response = await axios.post("Auth/login", { 
                    userName: this.userName,
                    password: this.password
                });

                this.posts = response.data;

                if (this.posts.success) {

                    // MFA required
                    if (this.posts.requiresMfa) {

                        sessionStorage.setItem('mfaSessionId', this.posts.mfaSessionId);
                        sessionStorage.setItem('mfaUserName', this.userName);

                        this.$showSuccess(this.posts.message);
                        this.$router.push('/mfa');
                    }
                    else {
                        // MFA not required (within 2 week validity)

                        // Persist token and user data until tab/browser is closed
                        sessionStorage.setItem('sheepbase-token', this.posts.token);
                        sessionStorage.setItem('user', JSON.stringify(this.posts.user));
                        sessionStorage.setItem('roleName', this.posts.user.roleName);
                                            
                        // Store today's date in localStorage for next-day expiration
                        const today = new Date().toDateString(); // e.g. "Mon Apr 22 2025"
                        localStorage.setItem('login-date', today);
                        
                        // Commit to Vuex
                        this.$store.commit('setShowNavbar', true);
                        this.$store.commit('user', this.posts.user);
                        
                        this.$store.commit('setRoleName', this.posts.user.roleName);

                        if(this.posts.user.roleName == 'Keeper') {
                            this.$store.commit('setKeeperAssociationId', this.posts.user.keeperAssociationId);
                            this.$store.commit('setKeeperRVORelationNumber', this.posts.user.keeperRVORelationNumber);
                            this.$store.commit('setKeeperRVOConnected', this.posts.user.keeperRVOConnected);
                        }
                        
                        if(this.posts.user.roleName == 'AssociationAdmin') {
                            this.$store.commit('setAssociationAdminAssociationId', this.posts.user.associationAdminAssociationId);
                        }

                        if(this.posts.user.roleName == 'Inspector') {
                            this.$store.commit('setInspectorAssociationId', this.posts.user.inspectorAssociationId);
                        }
                        
                        this.$store.commit('setAssociationWebsiteURL', this.posts.user.associationWebsiteURL);

                        // Set Axios defaults
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.posts.token;

                        // Navigate to dashboard or home
                        this.$router.push('/');
                                               
                    }
                } else {
                    const errorMessage = this.posts.message || this.$t('errors.Invalid_username_password');
                    this.$showError(errorMessage);
                }
            } catch (e) {

                const errorMessage =
                    e.response?.data?.message ||
                    e.message ||
                    this.$t('errors.Something_went_wrong');

                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }

            this.$store.commit('setShowLoading', false);
        },
    },
};
</script>
<style src="@/assets/css/auth.css"></style>
  